import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Alert, Box, Button, Chip, Paper, Stack, Tab, Tabs, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useTranslation } from "react-i18next";
import WorkspacesTabPanel from "./WorkspacesTabPanel";
import AnalyticsTabPanel from "./AnalyticsTabPanel";
import CatalogTabPanel from "./CatalogTabPanel";

const PlatformConsoleHome = () => {
  const { t } = useTranslation("app");
  const [tab, setTab] = useState(0);
  const [error, setError] = useState("");
  const [actionMessage, setActionMessage] = useState("");
  const [listKey, setListKey] = useState(0);
  const [analyticsKey, setAnalyticsKey] = useState(0);

  const refreshWorkspaces = () => setListKey((k) => k + 1);
  const refreshAnalytics = () => setAnalyticsKey((k) => k + 1);

  return (
    <Box sx={{ pt: 1, pb: 4 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" gap={2} sx={{ mb: 2 }}>
        <Box>
          <Chip label="xprobase" size="small" color="primary" variant="outlined" sx={{ mb: 1 }} />
          <Typography variant="h4">{t("platformPage.title")}</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, maxWidth: 720 }}>
            {t("platformPage.subtitle")}
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
            {t("platformPage.loginHint")}
          </Typography>
        </Box>
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          <Button component={RouterLink} to="/chat" variant="outlined" size="small">
            {t("platformPage.backChat")}
          </Button>
          <Button component={RouterLink} to="/settings/billing" variant="outlined" size="small">
            {t("platformPage.backBilling")}
          </Button>
          {tab === 0 ? (
            <Button startIcon={<RefreshIcon />} variant="outlined" size="small" onClick={refreshWorkspaces}>
              {t("billingPage.refresh")}
            </Button>
          ) : null}
          {tab === 1 ? (
            <Button startIcon={<RefreshIcon />} variant="outlined" size="small" onClick={refreshAnalytics}>
              {t("billingPage.refresh")}
            </Button>
          ) : null}
        </Stack>
      </Stack>

      {error ? (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError("")}>
          {error}
        </Alert>
      ) : null}
      {actionMessage ? (
        <Alert severity="success" sx={{ mb: 2 }} onClose={() => setActionMessage("")}>
          {actionMessage}
        </Alert>
      ) : null}

      <Paper
        variant="outlined"
        sx={(theme) => ({
          bgcolor: alpha(theme.palette.primary.main, 0.03),
          borderColor: "divider",
          overflow: "hidden",
        })}
      >
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            bgcolor: "background.paper",
            px: 1,
          }}
        >
          <Tab label={t("platformPage.tabWorkspaces")} />
          <Tab label={t("platformPage.tabAnalytics")} />
          <Tab label={t("platformPage.tabCatalogOps")} />
        </Tabs>

        <Box sx={{ p: 2.5, display: tab === 0 ? "block" : "none" }} role="tabpanel">
          <WorkspacesTabPanel key={listKey} />
        </Box>

        <Box sx={{ p: 2.5, display: tab === 1 ? "block" : "none" }} role="tabpanel">
          <AnalyticsTabPanel key={analyticsKey} />
        </Box>

        <Box sx={{ p: 2.5, display: tab === 2 ? "block" : "none" }} role="tabpanel">
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
            {t("billingPage.adminCatalogHint")}
          </Typography>
          <CatalogTabPanel
            onError={(msg) => {
              if (msg) setError(msg);
            }}
            onSuccess={(msg) => {
              if (msg) setActionMessage(msg);
            }}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default PlatformConsoleHome;
